import { render, staticRenderFns } from "./bomDialog.vue?vue&type=template&id=57f0d3c1"
import script from "./bomDialog.vue?vue&type=script&lang=js"
export * from "./bomDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports